<template>
  <div class="dialog-container">
    <yd-dialog
      :title="title + '操作日志'"
      :visible="visible"
      width="60%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <el-form ref="form" :inline="true" :model="form" label-width="80px" size="mini">
          <el-form-item label="操作时间">
            <el-date-picker
              v-model="form.date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              value="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              :clearable="false"
              :picker-options="pickerOptions"
              @change="handleDateChange"
            />
          </el-form-item>
          <el-form-item label="操作人">
            <yd-common-selector v-model="form.unionUserId" :options="opratorUser" />
          </el-form-item>
          <el-form-item label="操作类型">
            <yd-common-selector
              v-model="form.operateType"
              :options="flightPlanList"
              :multiple="operateTypeIsMultiple"
            />
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="getLogs">查询</el-button>
            <el-button size="mini" @click="handleClear">清空</el-button>
          </el-form-item>
        </el-form>

        <avue-crud
          height="max-height: 67vh"
          ref="crud"
          :table-loading="loading"
          :option="option"
          :data="logList"
          :page.sync="page"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="refreshChange"
        >
          <template slot="newRecord" slot-scope="{ row }">
            <div v-if="active === 1">{{ '城际订单号：' + row.orderNo + ' ' + row.newRecord }}</div>
            <div v-else-if="active === 2">
              {{ '同城订单号：' + row.orderNo + ' ' + row.newRecord }}
            </div>
            <el-tooltip v-else popper-class="log-tool-tip" effect="dark" placement="top">
              <template v-slot:content>
                <p>{{ row.newRecord }}</p>
              </template>
              <div
                style="width: 100; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
              >
                {{ row.newRecord }}
              </div>
            </el-tooltip>
          </template>
          <template slot="oldRecord" slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.oldRecord" placement="top-start">
              <div
                style="width: 100; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
              >
                {{ row.oldRecord }}
              </div>
            </el-tooltip>
          </template>
          <template slot="operatorName" slot-scope="{ row }">
            <yd-link
              v-if="row.operatorUserIdType === 2"
              :value="row.operatorName"
              :type="'systemUser'"
              :key="row.uuid"
              :query="{ userId: row.unionUserId }"
            />
            <span v-else>
              {{ row.operatorName }}
            </span>
          </template>
          <template slot="text" slot-scope="{ row }">
            <!--            white-space: nowrap; overflow: hidden; text-overflow: ellipsis-->
            <div style="width: 100%" v-for="item in row.textList" :key="item">{{ item }}</div>
          </template>
        </avue-crud>
      </div>
      <div slot="footer">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="mini">确 定</el-button>
      </div>
    </yd-dialog>
  </div>
</template>

<script>
  import { bizLogOperateType, pages, sysUserList } from '@/api/transport/bustime'
  import { uuidv5 } from '@/util'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      active: {
        type: String,
        default: ''
      },
      extendHeads: {
        type: Array,
        default: () => []
      },
      needFormat: {
        type: Boolean,
        default: false
      },
      formatParams: {
        type: Function,
        default: () => {}
      },
      needFormatResult: {
        type: Boolean,
        default: false
      },
      formatResult: {
        type: Function,
        default: () => {}
      },
      customRequest: {
        type: Boolean,
        default: false
      },
      request: {
        type: Function,
        default: () => {}
      },
      operateTypeList: {
        type: Array,
        default: () => []
      },
      operateTypeIsMultiple: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        loading: false,
        page: {
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 30, 50, 100],
          total: 0
        },
        option: {
          height: '40vh',
          addBtn: false,
          editBtn: false,
          border: true,
          menu: false,
          column: [
            {
              label: '操作时间',
              prop: 'recordTime',
              align: 'center',
              width: 160
            },
            {
              label: '操作方',
              prop: 'operator',
              width: 120,
              align: 'center'
            },
            {
              label: '操作人',
              prop: 'operatorName',
              width: 120,
              align: 'center'
            },
            {
              label: '操作类型',
              prop: 'operateTypeMsg',
              width: 120,
              align: 'center'
            }
          ],
          logList: [],
          page: {
            pages: 1,
            size: 10
          },
          total: 0
        },
        flightPlanList: [],
        form: {
          date: [],
          startTime: '',
          endTime: '',
          unionUserId: null,
          operateType: []
        },
        opratorUser: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() || time.getTime() < Date.now() - 8.64e7 * 30
          }
        }
      }
    },
    methods: {
      handleClose() {
        this.$emit('close')
        this.form = {}
      },
      handleSubmit() {
        this.handleClose()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.getLogs()
      },
      sizeChange(val) {
        this.page.pageSize = val
        this.getLogs()
      },
      refreshChange() {
        this.getLogs()
      },
      // 定点接送后台管理接
      async getBizLogOperateType() {
        const res = await bizLogOperateType()
        const { code, data } = res
        if (code !== 0 || !Array.isArray(data.operateType[this.active])) {
          return
        }
        data.operateType[this.active].forEach((it) => {
          it.label = it.operation
          it.value = it.code
        })
        this.flightPlanList = data.operateType[this.active]
      },
      // 分页获取日志
      async getLogs() {
        if (JSON.stringify(this.form.date) === '[]') {
          this.form.startTime = this.form.endTime = ''
        } else {
          this.form.startTime = this.form.date[0]
          this.form.endTime = this.form.date[1]
        }
        this.loading = true
        const http = this.customRequest ? this.request : pages
        const res = await http(
          this.needFormat
            ? this.formatParams({
                current: this.page.currentPage,
                index: 0,
                size: this.page.pageSize,
                ...this.form,
                bizType: this.active,
                userList: this.opratorUser
              })
            : {
                current: this.page.currentPage,
                index: 0,
                size: this.page.pageSize,
                ...this.form,
                bizType: this.active
              }
        )
        const { code, data } = res
        this.loading = false
        if (code !== 0) {
          return
        }
        const { records } = data || {}
        const list = Array.isArray(records)
          ? records.map((item) => {
              item.uuid = uuidv5()
              return item
            })
          : []
        this.logList = this.needFormatResult ? this.formatResult(list) : list
        this.page.total = data.total
      },
      async getSysUserList() {
        const { code, data } = await sysUserList()
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        data.forEach((it) => {
          it.label = it.userName
          it.value = it.userId
        })
        this.opratorUser = data
      },
      handleClear() {
        this.form = {
          date: ['', '']
        }
        this.getDate()
        this.getLogs()
      },
      // 获取默认时间
      getDate() {
        const date = new Date()
        const y = date.getFullYear()
        let m = date.getMonth() + 1
        m = this.changeFormat(m)
        let day = date.getDate()
        day = this.changeFormat(day)
        let h = date.getHours()
        h = this.changeFormat(h)
        let min = date.getMinutes()
        min = this.changeFormat(min)
        let s = date.getSeconds()
        s = this.changeFormat(s)
        this.form.date = [
          y + '-' + m + '-' + day + ' 00:00:00',
          y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s
        ]
      },
      changeFormat(data) {
        return (data + '').length === 1 ? '0' + data : data
      },
      handleDateChange(v) {
        this.form.date[1] = v[1]
      }
    },
    watch: {
      async visible() {
        if (this.visible) {
          if (this.extendHeads.length > 0) {
            this.extendHeads.forEach((item) => {
              !this.option.column.find((col) => col.label === item.label) &&
                this.option.column.push(item)
            })
          } else {
            if (this.active === 'sysUserAccount' && this.option.column.length < 5) {
              this.option.column.push(
                {
                  label: '操作内容',
                  prop: 'newRecord',
                  align: 'center'
                },
                {
                  label: '原内容',
                  prop: 'oldRecord',
                  align: 'center'
                }
              )
            }
            if (this.active !== 'sysUserAccount' && this.option.column.length < 5) {
              this.option.column.push({
                label: '日志内容',
                prop: 'newRecord',
                align: 'center'
              })

              this.option.column.push({
                label: '原内容',
                prop: 'oldRecord',
                align: 'center'
              })
            }
          }
          this.getDate()
          this.getSysUserList()
          if (this.operateTypeList.length > 0) {
            this.flightPlanList = this.operateTypeList
          } else {
            await this.getBizLogOperateType()
          }
          this.getLogs()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .avue-crud__pagination .el-pagination {
    display: inline-block !important;
  }
  ::v-deep .el-date-editor--datetimerange.el-input__inner {
    max-width: 350px !important;
  }
</style>
<style>
  .log-tool-tip {
    max-width: 60%;
  }
</style>
